module.exports = __webpack_public_path__ + "webStatic/img/logo_1.72939b02.png";